import { render, staticRenderFns } from "./PriceRangeSlider.vue?vue&type=template&id=10d8f458&scoped=true&"
import script from "./PriceRangeSlider.vue?vue&type=script&lang=js&"
export * from "./PriceRangeSlider.vue?vue&type=script&lang=js&"
import style0 from "./PriceRangeSlider.vue?vue&type=style&index=0&id=10d8f458&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10d8f458",
  null
  
)

export default component.exports